import React, {useEffect} from "react";
import useTerms from "../../../Global/Api/Settings/terms.api";

export default function Terms() {

  const { terms, get } = useTerms();

  useEffect(() => {
    get();
  }, []);

  return (
    <div className="faq">
      <h3 className="faq__title">{terms?.title}</h3>
      <div className="faq__text" dangerouslySetInnerHTML={{ __html: terms?.body }} />
    </div>
  );
}
